export default "__VITE_ASSET__B9lNtK99__";